import { getReportStatusBadgeConfig } from '@/lib/reports/status';
import { useTranslation } from 'react-i18next';
import type { Doc } from '~/convex/_generated/dataModel';
import { Badge } from '../ui/badge';

type ReportStatus = Doc<'reports'>['status'];

interface ReportStatusBadgeProps {
  status: ReportStatus;
  className?: string;
}

export const ReportStatusBadge = ({
  status,
  className,
}: ReportStatusBadgeProps) => {
  const { t } = useTranslation();
  const { labelKey, variant } = getReportStatusBadgeConfig(status);

  return (
    <Badge variant={variant} className={className}>
      {t(labelKey)}
    </Badge>
  );
};
